class CollectionViewToggle extends HTMLElement {
  constructor() {
    super()

    this.toggleButton = this.querySelectorAll('[data-collection-view-toggle]')
    this.toggleButton.forEach((button) => button.addEventListener('click', this.toggle.bind(this)))
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const viewString = event.currentTarget.dataset.collectionViewToggle

    // Get all the search params
    const urlParams = new URLSearchParams(window.location.search)

    // Remove or add view=alt as necessary
    if (viewString === 'alt') {
      if (!urlParams.has('view')) {
        urlParams.append('view', 'alt')
      }
    } else {
      urlParams.delete('view')
    }

    // Build the url with all the params (so we can retain selected filters)
    const paramsString = urlParams.toString()
    const url = `${window.location.pathname}${paramsString ? `?${paramsString}` : ''}`

    // Navigate
    window.location = url
  }
}

if (!customElements.get('collection-view-toggle')) {
  customElements.define('collection-view-toggle', CollectionViewToggle)
}
